import css from './AddExtraCard.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { GoodTicketCode } from 'types/tickets'

import { ButtonRed } from 'components/Actions/Action'
import Img from 'components/Media/Img'

interface Props {
  showAddExtraModal(show: boolean): void
  extraType: GoodTicketCode
}

const AddExtraCard: React.FC<Props> = (props) => {
  const { showAddExtraModal, extraType } = props

  const { t } = useTranslation()

  return (
    <div className={css.wrapper}>
      <div className={css.header}>{t(`wallet:add_extra_${extraType}_header`)}</div>
      <div className={css.description}>{t(`wallet:add_extra_${extraType}_description`)}</div>

      <Img className={css.caption} src={`/wallet/add-extra-${extraType}-caption.svg`} />

      <ButtonRed className={css.addExtraButton} onClick={() => showAddExtraModal(true)}>
        {t(`wallet:add_extra_button`)}
      </ButtonRed>
    </div>
  )
}

export default AddExtraCard
